import ReactGA from 'react-ga4';

// Initialize GA4
export const initGA = () => {
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  
  if (measurementId) {
    ReactGA.initialize(measurementId);
    console.log('GA4 initialized with measurement ID:', measurementId);
  } else {
    console.warn('GA4 measurement ID not found. Analytics will not be tracked.');
  }
};

// Track page views
export const trackPageView = (path) => {
  ReactGA.send({ hitType: "pageview", page: path });
};

// Track custom events
export const trackEvent = (category, action, label = null, value = null) => {
  ReactGA.event({
    category,
    action,
    label,
    value,
  });
};

// Track waitlist signups
export const trackWaitlistSignup = (email) => {
  trackEvent('Engagement', 'Waitlist Signup', 'Email Signup', 1);
  
  // Track with email (hashed for privacy)
  const hashedEmail = btoa(email).slice(0, 10); // Simple hash for demo
  trackEvent('User', 'Email Collected', hashedEmail, 1);
};

// Track button clicks
export const trackButtonClick = (buttonName, location = '') => {
  trackEvent('Engagement', 'Button Click', `${buttonName} - ${location}`, 1);
};

// Track form submissions
export const trackFormSubmission = (formName) => {
  trackEvent('Engagement', 'Form Submission', formName, 1);
};

// Track scroll depth
export const trackScrollDepth = (depth) => {
  trackEvent('Engagement', 'Scroll Depth', `${depth}%`, depth);
};

// Track time on page
export const trackTimeOnPage = (seconds) => {
  trackEvent('Engagement', 'Time on Page', `${Math.round(seconds)}s`, seconds);
};

// Track external link clicks
export const trackExternalLink = (url, linkText) => {
  trackEvent('Engagement', 'External Link Click', `${linkText} - ${url}`, 1);
};

// Track pricing plan interactions
export const trackPricingInteraction = (plan, action) => {
  trackEvent('Pricing', action, plan, 1);
};

// Track FAQ interactions
export const trackFAQInteraction = (question, action) => {
  trackEvent('FAQ', action, question, 1);
}; 